'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Thumbnail = require('@narvar/nth-bit-thumbnail');
var IconX = require('@narvar/nth-bit-icon-x');
var language_en_US = require('../../consts/language_en_US.js');
var index$2 = require('../Language/index.js');
var index = require('../FileUploadButton/index.js');
var index$1 = require('../IconFilledButton/index.js');
var FileUpload_module = require('./FileUpload.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);
var IconX__default = /*#__PURE__*/_interopDefaultLegacy(IconX);

const tempLanguageKeys = {
  returnsReasonsPicturesUploadErrorMaxSize: language_en_US["default"].returnsReasonsPicturesUploadErrorMaxSize,
  returnsReasonsPicturesUploadErrorMaxCount: language_en_US["default"].returnsReasonsPicturesUploadErrorMaxCount
};
const FileUpload = _ref => {
  let {
    label,
    caption,
    maxCount,
    value,
    onChange,
    ...props
  } = _ref;
  const {
    captiontextDefaultNone: captionStyle,
    captiontextErrorNone: captionStyleError
  } = nthHookTheme.useTheme();
  const {
    returnsReasonsPicturesUploadErrorMaxSize,
    returnsReasonsPicturesUploadErrorMaxCount
  } = tempLanguageKeys;
  const [errorCode, setErrorCode] = React.useState();
  const [files, setFiles] = React.useState([]);
  const previews = React.useMemo(() => files.map(file => ({
    name: file.name,
    type: file.type,
    url: URL.createObjectURL(file),
    file
  })), [files]);
  React.useEffect(() => {
    if (maxCount && maxCount > 0 && files.length > maxCount) {
      setErrorCode('maxCount');
    }
  }, [maxCount, files]);
  React.useEffect(() => {
    setFiles(value ?? []);
  }, [value]);
  const handleChange = (acceptFiles, rejectedFiles) => {
    const updates = [...files, ...acceptFiles];
    setFiles(updates);
    if ((rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 0) {
      setErrorCode('maxSize');
    } else {
      setErrorCode('');
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(updates);
  };
  const removeFile = file => {
    const updates = files.filter(f => f !== file);
    setFiles(updates);
    setErrorCode('');
    onChange === null || onChange === void 0 ? void 0 : onChange(updates);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index["default"], _extends__default["default"]({}, props, {
    onChange: handleChange
  }), label), caption && /*#__PURE__*/React__default["default"].createElement("div", {
    style: captionStyle
  }, caption), /*#__PURE__*/React__default["default"].createElement("div", {
    className: FileUpload_module["default"].previews
  }, previews.map((p, i) => /*#__PURE__*/React__default["default"].createElement("div", {
    className: FileUpload_module["default"].preview,
    key: i
  }, /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
    src: p.url,
    alt: p.name,
    s: {
      width: 150,
      display: 'block'
    }
  }), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    Icon: IconX__default["default"],
    s: {
      position: 'absolute',
      top: 4,
      right: 4
    },
    sIcon: {
      width: 12,
      height: 12
    },
    onClick: () => removeFile(p.file)
  })))), errorCode === 'maxSize' && /*#__PURE__*/React__default["default"].createElement("div", {
    style: captionStyleError
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    langKey: "returnsReasonsPicturesUploadErrorMaxSize",
    defaultString: returnsReasonsPicturesUploadErrorMaxSize
  })), errorCode === 'maxCount' && /*#__PURE__*/React__default["default"].createElement("div", {
    style: captionStyleError
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    langKey: "returnsReasonsPicturesUploadErrorMaxCount",
    defaultString: returnsReasonsPicturesUploadErrorMaxCount
  })));
};
var FileUpload$1 = nthHookTheme.withThemeProvider(FileUpload, {
  themeTokens: ['captiontextDefaultNone', 'captiontextErrorNone']
});

exports["default"] = FileUpload$1;
